import * as React from 'react';

import classNames from 'classnames';

import type {GetActivityForModal_activity as Activity} from 'nutshell-graphql-types';

import type {FormStatus} from '../../types';

import {ChangedBanner, SavedBanner, ErrorBanner, ReadOnlyBanner} from './form-banner-states';

import styles from './calendar.module.css';

type Props = {
    activity: Activity;
    formStatus: FormStatus;
    onCancel: () => void;
    onSave: () => void;
    isSaving: boolean;
    isCancelDisabled: boolean;
    updateError: string | null | undefined;
    isSlidingOut?: boolean;
};

export function FormStatusBanner(props: Props) {
    const {isSlidingOut = false} = props;
    const className = classNames(styles['form-status-banner'], {
        [styles['slide-up']]: !isSlidingOut,
        [styles['slide-down']]: isSlidingOut,
        [styles['form-status-banner--changed']]: props.formStatus === 'changed',
        [styles['form-status-banner--saved']]: props.formStatus === 'saved',
        [styles['form-status-banner--error']]: props.formStatus === 'error',
    });

    let bannerContent = null;
    if (props.formStatus === 'changed') {
        bannerContent = (
            <ChangedBanner
                onCancel={props.onCancel}
                onSave={props.onSave}
                isSaving={props.isSaving}
                isCancelDisabled={props.isCancelDisabled}
                activity={props.activity}
            />
        );
    } else if (props.formStatus === 'saved') {
        bannerContent = <SavedBanner />;
    } else if (props.formStatus === 'error') {
        bannerContent = <ErrorBanner updateError={props.updateError} />;
    } else if (props.formStatus === 'read-only') {
        bannerContent = <ReadOnlyBanner lockdownEmail={props.activity.syncOrganizerUsername} />;
    }

    return <div className={className}>{bannerContent}</div>;
}
